query SupportRequestsList(
  $page: Int
  $rowsPerPage: Int
  $filter: SupportRequestsFilterInput
) {
  supportRequests(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      number
      subject
      type
      status
      createdAt
      lastMessageAt
      waitingSince
      user {
        id
        email
      }
      assignee {
        id
        displayName
        email
      }
    }
  }
}
